module.exports = __webpack_public_path__ + "img/water_envi.33e8cbd1.svg";